window.Products.Clothing.PremiumTShirt = function() {
};
window.Products.Clothing.PremiumTShirt.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.PremiumTShirt.dpi = 150;
window.Products.Clothing.PremiumTShirt.has_3d = true;
window.Products.Clothing.PremiumTShirt.id = 101;
window.Products.Clothing.PremiumTShirt.slug = 'premium-t-shirt';
window.Products.Clothing.PremiumTShirt.syncColors = true;
window.Products.Clothing.PremiumTShirt.texturesLoaded = 0;
window.Products.Clothing.PremiumTShirt.texturesLoading = false;
window.Products.Clothing.PremiumTShirt.use_glb = true;

window.Products.Clothing.PremiumTShirt.prototype.outsideObject = 0;
window.Products.Clothing.PremiumTShirt.prototype.detailsObject = 1;
window.Products.Clothing.PremiumTShirt.prototype.position = 0.1;

window.Products.Clothing.PremiumTShirt.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather")){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.PremiumTShirt.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"coral": 0xe7674d,
		"dark_grey": 0x3c3835,
		"kelly": 0x024e2f,
		"natural": 0xf2ebdb,
		"pink": 0xfdc1c3,
		"navy": 0x262840,
		"red": 0xb22c36,
		"storm": 0x766d6c,
		"true_royal": 0x2d4e95,
		"yellow": 0xefd552,
		"royal_blue": 0x315ad7,
		"canvas_red": 0x921220,
		"athletic_heather": 0xc7c8c9,
	};

	return new THREE.Color(colors[_name]);
};